import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.sass';

// HOC for AMP page rendering
const AMPPage = ({ children }) => (
  <div className={styles.ampPage}>{children}</div>
);

AMPPage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
};

export default AMPPage;
